import { WifiOff } from "lucide-react";
import { Icon } from "@cntrl/ui";
import styles from "./dayOfShow.module.scss";

/**
 * The honest offline banner — the go-live posture for the day-of surfaces is ONLINE-FIRST: reads are
 * whatever react-query already cached (no IndexedDB persistence — that is [post-launch]) and writes are disabled
 * while the device reports offline. This is the truthful cue; the reused settlement/food/travel writes also
 * surface any network error verbatim (never a false success — the non-optimistic money rule).
 */
export function OfflineBanner() {
  return (
    <div className={styles.offlineBanner} role="status" aria-live="polite" data-testid="offline-banner">
      <Icon icon={WifiOff} size={16} />
      <span>You're offline — showing the latest loaded data. Changes are paused until you reconnect.</span>
    </div>
  );
}
